/**
 * Parámetros de encuadre de la miniatura del mapa.
 *
 * Vive acá y no suelto en cada archivo porque el zoom tiene que estar a la vez
 * en la URL que genera el servidor (/api/map-static) y en la clave con la que
 * el CDN cachea esa respuesta.
 *
 * El cache es de un año y la clave es la URL. Como las coordenadas y el zoom no
 * viajaban en la URL, cambiar el encuadre no invalidaba nada: el CDN seguía
 * devolviendo la foto vieja. Pasó de verdad al pasar de 14.5 a 15.5.
 *
 * Por eso el componente manda `v=<lng>,<lat>,<zoom>`: el servidor lo ignora,
 * pero cualquier cambio de encuadre produce una URL distinta y el CDN
 * regenera. Si tocás THUMBNAIL_ZOOM, la invalidación sale sola.
 */
export const THUMBNAIL_ZOOM = 15.5;
